function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useCallback } from "react";
import { FilterContext, UserContext, SearchContext } from "../index";
import { UPDATE_PROJECT_SETTINGS_MUTATION, GET_PROJECT_SETTINGS_QUERY } from "./query";
import { PROJECT_USER_DETAILS_DATA_QUERY } from "./../MyProjects/query";
import { useQuery, useMutation } from "@apollo/client";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Field, Form as FormikForm, Formik } from "formik";
import * as Yup from "yup";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Loader from "./../Loader/Loader";
import { toast } from "react-toastify";
import SearchBar from "../SearchBar";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import classNames from "classnames";
import "./ProjectSettings.css";
var ProjectSettings = function ProjectSettings(props) {
  var _React$useContext = React.useContext(UserContext),
    user = _React$useContext.user;
  var _React$useContext2 = React.useContext(FilterContext),
    teamId = _React$useContext2.teamId,
    organisationId = _React$useContext2.organisationId,
    role = _React$useContext2.role,
    organisationBilling = _React$useContext2.organisationBilling,
    from = _React$useContext2.from;
  React.useEffect(function () {
    if (from == "web" && role === "Member") {
      props === null || props === void 0 ? void 0 : props.history.push("/timesheet");
    }
  }, [role]);
  React.useEffect(function () {
    if ((organisationBilling === null || organisationBilling === void 0 ? void 0 : organisationBilling.planStatus) === "stopped") {
      props === null || props === void 0 ? void 0 : props.history.push("/billing");
    }
  }, [organisationBilling]);
  var loadPage = role === "Admin" || role === null;
  var Redirect = props.redirect;
  var _useQuery = useQuery(GET_PROJECT_SETTINGS_QUERY, {
      variables: {
        organisationId: organisationId
      },
      skip: !organisationId
    }),
    projectSettingsData = _useQuery.data,
    projectSettingsError = _useQuery.error,
    projectSettingsLoading = _useQuery.loading;
  if (projectSettingsLoading) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  if (projectSettingsError) {
    return /*#__PURE__*/React.createElement("div", null, "Error");
  }
  return /*#__PURE__*/React.createElement(ProjectSettingsForm, {
    organisationId: organisationId,
    userId: user.userId,
    projectSettingsData: projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.getProjectSettings
  });
};
var ProjectSettingsForm = function ProjectSettingsForm(props) {
  var organisationId = props.organisationId,
    userId = props.userId,
    projectSettingsData = props.projectSettingsData;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isProjectSettings = _React$useState2[0],
    setProjectSettings = _React$useState2[1];
  var _React$useState3 = React.useState(projectSettingsData !== null && projectSettingsData !== void 0 && projectSettingsData.projectSettingsUser ? projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.projectSettingsUser : []),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    enabledProjectUser = _React$useState4[0],
    setEnabledProjectUser = _React$useState4[1];
  function handleCloseProjectSettings() {
    setProjectSettings(false);
  }
  var _useMutation = useMutation(UPDATE_PROJECT_SETTINGS_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    updateProjectSettings = _useMutation2[0],
    updateProjectSettingsLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values) {
      var variables, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            variables = _objectSpread({
              organisationId: organisationId,
              userId: userId,
              userIds: enabledProjectUser
            }, values);
            _context.next = 3;
            return updateProjectSettings({
              variables: variables
            });
          case 3:
            response = _context.sent;
            if (!(!response || !response.data || !response.data.updateProjectSettings)) {
              _context.next = 8;
              break;
            }
            throw new Error("Error Occured, try again");
          case 8:
            handleCloseProjectSettings();
            toast.success("Project settings added successfully!");
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [updateProjectSettings, updateProjectSettingsLoading, enabledProjectUser]);
  return /*#__PURE__*/React.createElement("div", {
    className: "project-settings-card"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      enableProjectManagement: projectSettingsData && projectSettingsData !== null && projectSettingsData !== void 0 && projectSettingsData.projectManagementFeature ? projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.projectManagementFeature : "true",
      accessDesktopApplication: projectSettingsData && projectSettingsData !== null && projectSettingsData !== void 0 && projectSettingsData.accessDesktopApplication ? projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.accessDesktopApplication : "everyone",
      whoCanAddNewProject: projectSettingsData && projectSettingsData !== null && projectSettingsData !== void 0 && projectSettingsData.whoCanAddNewProject ? projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.whoCanAddNewProject : "admin",
      whoCanAddNewTaskToProject: projectSettingsData && projectSettingsData !== null && projectSettingsData !== void 0 && projectSettingsData.whoCanAddNewTaskToProject ? projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.whoCanAddNewTaskToProject : "admin&head",
      enableManualTimeFeature: projectSettingsData && projectSettingsData !== null && projectSettingsData !== void 0 && projectSettingsData.manualTimeFeature ? projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.manualTimeFeature : "false"
    },
    onSubmit: handleSubmit
  }, function (_ref2) {
    var isSubmitting = _ref2.isSubmitting,
      values = _ref2.values,
      setFieldValue = _ref2.setFieldValue;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, {
      className: "project-settings-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-settings-row-grid"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Project Settings"), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-project-management-card-root project-settings-project-management-enable-card-root"
    }, /*#__PURE__*/React.createElement("div", {
      id: "project-settings-enable-project-management",
      className: "project-settings-project-management-card-title"
    }, "Enable Project Management to your organisation"), /*#__PURE__*/React.createElement(Form.Group, {
      className: "project-settings-enable-project-management-card project-settings-radio-button-card"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "enableProjectManagement",
      checked: values.enableProjectManagement == "true",
      label: "Enable project management to everyone",
      id: "enable-project-management-1",
      className: "enable-project-management-1",
      value: "true"
    }), "Yes"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "enableProjectManagement",
      checked: values.enableProjectManagement == "false",
      label: "Enable project management to everyone",
      id: "enable-project-management-2",
      className: "enable-project-management-2",
      value: "false"
    }), "No"))), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-project-management-card-root"
    }, /*#__PURE__*/React.createElement("div", {
      id: "project-settings-enable-project-management",
      className: "project-settings-project-management-card-title"
    }, "Who can access Project Management in Desktop Application?"), /*#__PURE__*/React.createElement(Form.Group, {
      className: "project-settings-access-desktop-application-card project-settings-radio-button-card"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "accessDesktopApplication",
      checked: values.accessDesktopApplication == "everyone",
      label: "access desktop application",
      id: "access-desktop-application-1",
      className: "access-desktop-application-1",
      value: "everyone"
    }), "Everyone"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "accessDesktopApplication",
      checked: values.accessDesktopApplication == "member",
      label: "Enable project management to everyone",
      id: "access-desktop-applicationt-2",
      className: "access-desktop-applicationt-2",
      value: "member",
      onChange: function onChange() {
        setFieldValue("accessDesktopApplication", "member");
      },
      onClick: function onClick() {
        setProjectSettings(true);
      }
    }), "Selective Members ".concat(enabledProjectUser && enabledProjectUser.length != 0 ? " (".concat(enabledProjectUser.length > 1 ? "".concat(enabledProjectUser.length, " members") : "".concat(enabledProjectUser.length, " member"), "  selected)") : ""))))), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "User Settings"), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-project-management-card-root project-settings-project-management-new-project-card-root"
    }, /*#__PURE__*/React.createElement("div", {
      id: "project-settings-enable-project-management",
      className: "project-settings-project-management-card-title"
    }, "Who can add a new project?"), /*#__PURE__*/React.createElement(Form.Group, {
      className: "project-settings-who-can-add-new-project-card project-settings-radio-button-card"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "whoCanAddNewProject",
      checked: values.whoCanAddNewProject == "admin",
      label: "access desktop application",
      id: "who-can-add-new-project-1",
      className: "who-can-add-new-project-1",
      value: "everyone"
    }), "Everyone"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "whoCanAddNewProject",
      checked: values.whoCanAddNewProject == "teamHead",
      label: "access desktop application",
      id: "who-can-add-new-project-2",
      className: "who-can-add-new-project-2",
      value: "teamHead"
    }), "Team Head"))), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-project-management-card-root"
    }, /*#__PURE__*/React.createElement("div", {
      id: "project-settings-enable-project-management",
      className: "project-settings-project-management-card-title"
    }, "Who can add a new tasks to project?"), /*#__PURE__*/React.createElement(Form.Group, {
      className: "project-settings-who-can-add-new-task-to-project-card project-settings-radio-button-card"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "whoCanAddNewTaskToProject",
      checked: values.whoCanAddNewTaskToProject == "admin&head",
      label: "who-can-add-new-task-to-project",
      id: "who-can-add-new-task-to-project-1",
      className: "who-can-add-new-task-to-project-1",
      value: "admin&head"
    }), "Admin & Team Head"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "whoCanAddNewTaskToProject",
      checked: values.whoCanAddNewTaskToProject == "everyone",
      label: "who-can-add-new-task-to-project",
      id: "who-can-add-new-task-to-project-2",
      className: "who-can-add-new-task-to-project-2",
      value: "everyone"
    }), "Everyone(Including Team Member)")))), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-row-grid-card"
    }, /*#__PURE__*/React.createElement("h6", null, "Manual Time Settings"), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-project-management-card-root"
    }, /*#__PURE__*/React.createElement("div", {
      id: "project-settings-enable-project-management",
      className: "project-settings-project-management-card-title"
    }, "Enable manual time feature to your organisation"), /*#__PURE__*/React.createElement(Form.Group, {
      className: "project-settings-enable-manual-time-feature-card project-settings-radio-button-card"
    }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "enableManualTimeFeature",
      checked: values.enableManualTimeFeature == "true",
      label: "enable-manual-time-feature",
      id: "enable-manual-time-feature-1",
      className: "enable-manual-time-feature-1",
      value: "true"
    }), "Yes"), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Field, {
      type: "radio",
      name: "enableManualTimeFeature",
      checked: values.enableManualTimeFeature == "false",
      label: "enable-manual-time-feature",
      id: "enable-manual-time-feature-2",
      className: "enable-manual-time-feature-2",
      value: "false"
    }), "No")))), /*#__PURE__*/React.createElement("div", {
      xs: 12,
      md: 12,
      className: "timesheet-setting-sub-button-div"
    }, /*#__PURE__*/React.createElement(Button, {
      className: "timesheet-setting-sub-button",
      type: "submit",
      disabled: updateProjectSettingsLoading
    }, updateProjectSettingsLoading ? "Loading..." : "Save Project Settings")))));
  }), /*#__PURE__*/React.createElement(EnableMyProjectSettings, {
    handleCloseProjectSettings: handleCloseProjectSettings,
    organisationId: organisationId,
    userId: userId,
    isProjectSettings: isProjectSettings,
    enabledProjectUser: enabledProjectUser,
    setEnabledProjectUser: setEnabledProjectUser,
    projectSettingsUser: projectSettingsData === null || projectSettingsData === void 0 ? void 0 : projectSettingsData.projectSettingsUser
  }));
};
var EnableMyProjectSettings = function EnableMyProjectSettings(props) {
  var handleCloseProjectSettings = props.handleCloseProjectSettings,
    organisationId = props.organisationId,
    userId = props.userId,
    isProjectSettings = props.isProjectSettings,
    enabledProjectUser = props.enabledProjectUser,
    setEnabledProjectUser = props.setEnabledProjectUser,
    projectSettingsUser = props.projectSettingsUser;
  if (!isProjectSettings) {
    return null;
  }
  var _useQuery2 = useQuery(PROJECT_USER_DETAILS_DATA_QUERY, {
      variables: {
        organisationId: organisationId,
        projectId: null
      },
      skip: !organisationId
    }),
    tasksOptionsData = _useQuery2.data,
    tasksOptionsError = _useQuery2.error,
    tasksOptionsLoading = _useQuery2.loading;
  var _React$useState5 = React.useState(true),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isPriorityCheck = _React$useState6[0],
    setIsPriorityCheck = _React$useState6[1];
  var _React$useState7 = React.useState(""),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    searchUser = _React$useState8[0],
    setSearchUser = _React$useState8[1]; // SEARCH SETTINGS
  // const [userActive, setUserActive] = React.useState([]);
  var _React$useState9 = React.useState([]),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    userDetailsList = _React$useState10[0],
    setUserDetailsList = _React$useState10[1];
  var _React$useState11 = React.useState([]),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    userDetailsIds = _React$useState12[0],
    setUserDetailsIds = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    userSelected = _React$useState14[0],
    setUserSelected = _React$useState14[1];
  var _React$useState15 = React.useState(projectSettingsUser.length ? projectSettingsUser : []),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    userSelectedIds = _React$useState16[0],
    setUserSelectedIds = _React$useState16[1];
  var _React$useState17 = React.useState(null),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    keyData = _React$useState18[0],
    setKeyData = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    isCheck = _React$useState20[0],
    setIsCheck = _React$useState20[1];
  React.useEffect(function () {
    var _tasksOptionsData$get, _tasksOptionsData$get2;
    var userDetailsTemp = [];
    var userIds = [];
    tasksOptionsData === null || tasksOptionsData === void 0 ? void 0 : (_tasksOptionsData$get = tasksOptionsData.getProjectUserDetails) === null || _tasksOptionsData$get === void 0 ? void 0 : (_tasksOptionsData$get2 = _tasksOptionsData$get.teamUserList) === null || _tasksOptionsData$get2 === void 0 ? void 0 : _tasksOptionsData$get2.map(function (team) {
      var _team$user;
      team === null || team === void 0 ? void 0 : (_team$user = team.user) === null || _team$user === void 0 ? void 0 : _team$user.map(function (user) {
        var found = userDetailsTemp.some(function (el) {
          return el.userId === user.userId;
        });
        if (!found) {
          userDetailsTemp.push({
            displayName: user.displayName,
            userId: user.userId,
            profileUrl: user.profileUrl
          });
          userIds.push(user.userId);
        }
      });
    });
    setUserDetailsList(userDetailsTemp);
    setUserDetailsIds(userIds);
  }, [tasksOptionsData]);
  var handleKey = function handleKey(key) {
    setKeyData(key);
    setIsCheck(function (prev) {
      return prev === true ? false : true;
    });
  };
  var userWithSearch = function userWithSearch(teamData) {
    if (!searchUser) {
      return userDetailsList;
    }
    // return teamData.filter((filterteamData) => filterteamData?.teamName?.includes(searchTeam.toLowerCase()));
    return userDetailsList.filter(function (user) {
      var _user$displayName, _user$displayName$toL, _user$displayName$toL2, _user$displayName$toL3;
      return user === null || user === void 0 ? void 0 : (_user$displayName = user.displayName) === null || _user$displayName === void 0 ? void 0 : (_user$displayName$toL = _user$displayName.toLowerCase) === null || _user$displayName$toL === void 0 ? void 0 : (_user$displayName$toL2 = _user$displayName$toL.call(_user$displayName)) === null || _user$displayName$toL2 === void 0 ? void 0 : (_user$displayName$toL3 = _user$displayName$toL2.includes) === null || _user$displayName$toL3 === void 0 ? void 0 : _user$displayName$toL3.call(_user$displayName$toL2, searchUser.toLowerCase());
    });
  };
  return /*#__PURE__*/React.createElement(Modal, {
    show: isProjectSettings,
    onHide: handleCloseProjectSettings,
    centered: true,
    className: "my-projects-project-settings-modal-root"
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    closeButton: true,
    className: "my-projects-project-settings-modal-header"
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    className: "my-projects-project-settings-modal-title"
  }, "Select Project Users")), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      settingsType: "",
      user: []
    }
    // validationSchema={projectSettingsSchema}
    // onSubmit={handleProjectSettingsSubmit}
  }, function (_ref3) {
    var _userWithSearch;
    var setFieldValue = _ref3.setFieldValue,
      errors = _ref3.errors,
      touched = _ref3.touched,
      values = _ref3.values;
    return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
      className: "my-projects-project-settings-modal-content-row"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "project-settings-tasks-modal-content-person-name"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-settings-tasks-modal-content-person-name-header"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-project-settings-modal-content-person-name-header-section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "my-projects-project-settings-modal-content-person-name-header-section-content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-settings-project-task-modals-searchbox-wrapper"
    }, /*#__PURE__*/React.createElement(SearchBar, {
      value: searchUser,
      onChange: setSearchUser,
      placeholder: "Search Users",
      className: "project-settings-project-task-modals-searchbox-wrapper-input"
    }), userSelectedIds && userDetailsList && (userSelectedIds === null || userSelectedIds === void 0 ? void 0 : userSelectedIds.length) > 0 && (userDetailsList === null || userDetailsList === void 0 ? void 0 : userDetailsList.length) > 0 && (userSelectedIds === null || userSelectedIds === void 0 ? void 0 : userSelectedIds.length) == (userDetailsList === null || userDetailsList === void 0 ? void 0 : userDetailsList.length) ? /*#__PURE__*/React.createElement("p", {
      className: "project-settings-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserSelectedIds([]);
        setUserSelected(true);
      }
    }, "Unselect All Users") : /*#__PURE__*/React.createElement("p", {
      //variant="outline-secondary"
      className: "project-settings-tasks-modal-content-person-name-header-button",
      onClick: function onClick() {
        setUserSelectedIds(userDetailsIds);
        setUserSelected(true);
      }
    }, "Select All Users"))))), /*#__PURE__*/React.createElement("div", {
      className: "project-settings-tasks-modal-content-person-name-listing"
    }, tasksOptionsLoading ? /*#__PURE__*/React.createElement(Loader, null) : userDetailsList && userWithSearch(userDetailsList).length > 0 ? (_userWithSearch = userWithSearch(userDetailsList)) === null || _userWithSearch === void 0 ? void 0 : _userWithSearch.map(function (user, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: "project-settings-project-task-modals-content-person-name-listing-card-content",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "project-settings-tasks-modal-content-person-name-listing-card-content-person",
        onClick: function onClick() {
          setUserSelected(true);
          setUserSelectedIds(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      }, user.profileUrl ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "project-settings-task-card-avatar-profile"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "Workfolio",
        src: user === null || user === void 0 ? void 0 : user.profileUrl,
        className: "project-settings-task-card-avatar-profile-img"
      }))) : /*#__PURE__*/React.createElement("div", {
        className: "project-settings-tasks-modal-content-person-name-listing-card-content-person-icon"
      }, user.displayName ? user.displayName.charAt(0).toUpperCase() : ""), /*#__PURE__*/React.createElement("div", {
        className: "project-settings-my-projects-modal-content-header-team-name"
      }, user.displayName)), /*#__PURE__*/React.createElement("div", {
        className: "project-settings-my-projects-modal-content-team-name"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: user.userId,
        name: "myRadioGroup",
        className: "project-settings-create-project-team-selection-control-checkbox",
        checked: userSelectedIds.includes(user.userId),
        onChange: function onChange() {
          setUserSelected(true);
          setUserSelectedIds(function (prev) {
            return prev.includes(user.userId) ? prev.filter(function (a) {
              return a !== user.userId;
            }) : [].concat(_toConsumableArray(prev), [user.userId]);
          });
        }
      })));
    }) : /*#__PURE__*/React.createElement("div", {
      className: "project-settings-project-task-modals-content-person-name-listing-card-content"
    }, "No data"))))), /*#__PURE__*/React.createElement(Row, {
      className: "project-settings-add-project-modal-button-rows"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12,
      lg: 12,
      className: "project-settings-projects-create-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "project-settings-my-projects-modal-button"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "primary",
      className: "project-settings-my-projects-modal-save-button"
      // type="submit"
      // disabled={updateProjectSettingsLoading}
      ,
      onClick: function onClick() {
        setEnabledProjectUser(userSelectedIds);
        handleCloseProjectSettings();
      }
    }, "Save List"))))))));
  })));
};
export default ProjectSettings;